import { Text } from '@foss/legion-ui'
import { CodeBlock } from '../content/CodeBlock'
import { Workspace } from '../workspace/Workspace'
import prose from '../content/Prose.module.css'

const NPMRC = `@foss:registry=https://gitlab.glab.fyi/api/v4/packages/npm/
//gitlab.glab.fyi/:_authToken=\${LEGION_NPM_TOKEN}`

const SETUP = `import '@foss/legion-ui/styles.css'
import { LegionProvider, Button } from '@foss/legion-ui'

export function App() {
  return (
    <LegionProvider scope="root">
      <Button>Save changes</Button>
    </LegionProvider>
  )
}`

export function GettingStarted() {
  return (
    <div className={prose.prose} data-testid="getting-started">
      <section className={prose.section}>
        <Text variant="heading" as="h2">
          Install
        </Text>
        <Text>
          legion-ui is published privately to the GitLab package registry, so
          npm needs a token before it can resolve the <code>@foss</code> scope.
          A personal token with <code>read_api</code>, or a deploy token with{' '}
          <code>read_package_registry</code>, is enough — the docs site itself
          never publishes.
        </Text>
        <CodeBlock label=".npmrc">{NPMRC}</CodeBlock>
        <Text>
          The auth line is host-wide on purpose. GitLab serves package metadata
          from <code>/api/v4/packages/npm/</code> but tarballs from{' '}
          <code>/api/v4/projects/&lt;id&gt;/packages/npm/</code>, and npm
          matches credentials by URI prefix — a key scoped to the metadata path
          alone leaves the tarball fetch unauthenticated, which GitLab answers
          with a misleading <code>404 Project not found</code>.
        </Text>
        <CodeBlock label="bash">npm install @foss/legion-ui</CodeBlock>
        <Text tone="muted">
          React and react-dom are peer dependencies (<code>&gt;=17</code>) and
          are not bundled. Neither are the fonts.
        </Text>
      </section>

      <section className={prose.section}>
        <Text variant="heading" as="h2">
          Set it up
        </Text>
        <Text>
          Import the stylesheet once, at your app root, then wrap the tree in a{' '}
          <code>LegionProvider</code>. With <code>scope=&quot;root&quot;</code>{' '}
          the theme is written to <code>documentElement</code>, so portalled
          content — dialogs, menus, tooltips — is themed too.
        </Text>
        <CodeBlock label="App.tsx">{SETUP}</CodeBlock>
      </section>

      <section className={prose.section}>
        <Text variant="heading" as="h2">
          Try it
        </Text>
        <Text>
          Every component page carries an example like this one. Edit the source
          and the component above it re-renders. Break it and you get an error
          with the last working version still on screen.
        </Text>
        <Workspace
          name="GettingStarted"
          source={`<Stack direction="row" gap={3} align="center">
  <Button>Save changes</Button>
  <Button variant="secondary">Preview</Button>
</Stack>`}
        />
      </section>
    </div>
  )
}
